export default __webpack_public_path__ + "static/media/6.b8c43a6a.jpg";